/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import PortfolioSingleGrid from "../PorfolioSingleGrid";
import Portfolio from "../../data/portfolio.json";
import ImageViewer from "react-simple-image-viewer";
import VideoPlayer from "../VideoPlayer";

export default function Works() {
  const [openImageViewer, setOpenImageViewer] = useState(false);
  const [imageViewerIndex, setImageViewerIndex] = useState(0);
  const [imageViewerCategory, setImageViewerCategory] = useState("photography");
  const [openVideoPlayer, setOpenVideoPlayer] = useState(false);
  const [currentVideoDesc, setCurrentVideoDesc] = useState("");

  const images = Portfolio.map((p) => {
    if (imageViewerCategory === "all" && p.category !== "videography") {
      return p.link;
    }
    if (p.category === imageViewerCategory) {
      return p.link;
    }

    return [];
  }).filter(String);

  const videos = Portfolio.map((p) => {
    if (p.category === "videography") {
      return p.videoLink;
    }
    return [];
  }).filter(String);

  const onGridClick = (p) => {
    if (p.category === "videography") {
      setCurrentVideoDesc(p.videoDesc || "");
      setOpenVideoPlayer(true);
      const index = videos.indexOf(p.videoLink);
      setImageViewerIndex(index);
    } else {
      setOpenImageViewer(true);
      const index = images.indexOf(p.link);
      setImageViewerIndex(index);
    }
  };

  const videoDescHandler = (index) => {
    const url = videos[index];
    const { videoDesc } = Portfolio.find((p) => p.videoLink === url);
    setCurrentVideoDesc(videoDesc || "");
  };

  return (
    <>
      <section className="section site-portfolio">
        <div className="container">
          <div className="row mb-5 align-items-center">
            <div className="col-md-12 col-lg-6 mb-4 mb-lg-0" data-aos="fade-up">
              <h2>Hey, I'm Waleed Shahab</h2>
              <p className="mb-0">Video Editor, Photographer &amp; Graphics Designer</p>
            </div>
            <div className="col-md-12 col-lg-6 text-start text-lg-end" data-aos="fade-up" data-aos-delay="100">
              <div id="filters" className="filters">
                {/* <a href="#" data-filter="*" className={imageViewerCategory === "all" ? "active" : ""} onClick={() => setImageViewerCategory("all")}>
                  All
                </a> */}
                <a href="#" data-filter=".photography" className={imageViewerCategory === "photography" ? "active" : ""} onClick={() => setImageViewerCategory("photography")}>
                  Photography
                </a>
                <a href="#" data-filter=".videography" className={imageViewerCategory === "videography" ? "active" : ""} onClick={() => setImageViewerCategory("videography")}>
                  Videography
                </a>
                <a href="#" data-filter=".design" className={imageViewerCategory === "design" ? "active" : ""} onClick={() => setImageViewerCategory("design")}>
                  Design
                </a>
              </div>
            </div>
          </div>
          <div id="portfolio-grid" className="row no-gutter" data-aos="fade-up" data-aos-delay="200">
            {Portfolio.filter((p) => p.category === imageViewerCategory || imageViewerCategory === "all").map((p) => {
              return (
                <PortfolioSingleGrid
                  title={p.title}
                  type={p.type}
                  link={p.link}
                  category={p.category}
                  key={p.title}
                  onImageClick={() => {
                    onGridClick(p);
                  }}
                />
              );
            })}
          </div>
        </div>
      </section>
      {openImageViewer && (
        <ImageViewer
          src={images}
          currentIndex={imageViewerIndex}
          disableScroll={true}
          closeOnClickOutside={true}
          onClose={() => setOpenImageViewer(false)}
          leftArrowComponent={<span className="bi bi-arrow-left-circle-fill"></span>}
          rightArrowComponent={<span className="bi bi-arrow-right-circle-fill"></span>}
          closeComponent={<span className="bi bi-x"></span>}
        />
      )}
      {openVideoPlayer && (
        <VideoPlayer
          desc={currentVideoDesc}
          videos={videos}
          currentIndex={imageViewerIndex}
          onClose={() => {
            setOpenVideoPlayer(false);
          }}
          onChangeIndex={(index) => {
            setImageViewerIndex(index);
            videoDescHandler(index);
          }}
        />
      )}
    </>
  );
}
